import { render, staticRenderFns } from "./AlertSave.vue?vue&type=template&id=60a2e5d3&scoped=true&"
import script from "./AlertSave.vue?vue&type=script&lang=js&"
export * from "./AlertSave.vue?vue&type=script&lang=js&"
import style0 from "./AlertSave.vue?vue&type=style&index=0&id=60a2e5d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2e5d3",
  null
  
)

export default component.exports